/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left2" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right2" /></svg></button>';

	const more = () => {
		const $brandList = $('.js-index-more-content li');
		if($('.js-index-more').length) {
			let startCnt = 0, endCnt = 4;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($brandList.eq(i).length) {
						$brandList.eq(i).addClass(v);
						$('.js-index-more').addClass(v)
					} else {
						$('.js-index-more').remove();
						break;
					}
				}
			};
			// 最初の10件表示
			addResult();
			if($brandList.length <= 4) { $('.js-index-more').remove(); }
			// moreボタン押下で10件ずつ追加表示
			$('.js-index-more').on('click', () => {
				startCnt += 4; endCnt += 12;
				addResult();
			});
		}
	};

	const slide = () => {
		if($('.js-index-newProd-slide').length) {
			$('.js-index-newProd-slide').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 5,
				swipeToSlide: true,
				arrows: false,
				dots: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
						}
					}
				]
			});
		}
		if($('.js-index-campaign-slide').length) {
			$('.js-index-campaign-slide').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 3,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		}
		if($('.js-index-main-slide').length) {
			$('.js-index-main-slide').slick({
				infinite: true,
				fade: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				arrows: false,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
			});
			//slide内ロゴ表示
			setTimeout(function() {
				$('.index-slider-logo').addClass('is-active');
			}, 500);
		}
	};

	const videoTelop = () => {
		$('#js-mainVideo').on('timeupdate', function(event){

			// テキスト1表示
			if ($(this)[0].currentTime >= 1) {
				$('.index-main-copy-txt01').addClass(v);
			}
			// テキスト1非表示
			if($(this)[0].currentTime >= 14) {
				$('.index-main-copy-txt01').removeClass(v);
			}
			// テキスト2表示
			if($(this)[0].currentTime >= 15) {
				$('.index-main-copy-txt02').addClass(v);
			}
			// テキスト2非表示
			if($(this)[0].currentTime >= 19) {
				$('.index-main-copy-txt02').removeClass(v);
			}
			// テキスト1表示
			if($(this)[0].currentTime >= 20) {
				$('.index-main-copy-txt01').addClass(v);
			}
			// テキスト1非表示
			if($(this)[0].currentTime >= 42) {
				$('.index-main-copy-txt01').removeClass(v);
			}
			// テキスト3表示
			if($(this)[0].currentTime >= 43) {
				$('.index-main-copy-txt03').addClass(v);
			}
			// テキスト3非表示
			if($(this)[0].currentTime >= 54) {
				$('.index-main-copy-txt03').removeClass(v);	
			}
			
		});
	};

	// FInd BOURBON
	const findBOURBONdatalabel = () => {
		if($('.rt_bn_findbourbon_list').length) {
			$('.rt_bn_findbourbon_list').each((idx, ele) => {
				let thisLink = $(ele).find('.index-block01-inner-item');
				let thisHref = thisLink.attr('href').split('/');
				let thisID = thisHref[thisHref.length -1].replace('.html', '');
				if(thisID === '20210323195445') {
					thisLink.attr('data-label', 'densetsu');
				} else if(thisID === '20210323201743') {
					thisLink.attr('data-label', 'setsuritsu');
				} else if(thisID === '20210323201928') {
					thisLink.attr('data-label', 'Keene');
				}
			});
		}
	};


	more();
	slide();
	videoTelop();
	findBOURBONdatalabel();

})(window.jQuery, window.FUNCTIONS);
